import { sessionIDRegex, regexDispute } from './config';

export const handleCheckingSessionID = (string) => {
  if (string === null || string.length === 0) return false;

  if (string.match(regexDispute)) {
    return false;
  }
  const id =
    (string.match(sessionIDRegex) && string.match(sessionIDRegex)[0]) || false;
  if (id) return id;
  return false;
};
